var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-add-result"},[(_vm.status === _vm.STATUS_MAP.success)?_c('Succeed'):_vm._e(),(_vm.status === _vm.STATUS_MAP.failed)?_c('Failed'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }